// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"9503a9b9","399":"84cf2627","436":"effdb7a2","453":"87f6c0b3","502":"20f38951","747":"64a3fe7a","791":"d1553c5b","835":"896a1084"}[chunkId] + ".chunk.js";
};